/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ km: NonNullable<unknown> }} Ui_Studio_Pick_From_SplitInputs */

const en_ui_studio_pick_from_split = /** @type {(inputs: Ui_Studio_Pick_From_SplitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.km} km from last split`)
};

const de_ui_studio_pick_from_split = /** @type {(inputs: Ui_Studio_Pick_From_SplitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.km} km ab letztem Teiler`)
};

/**
* | output |
* | --- |
* | "{km} km from last split" |
*
* @param {Ui_Studio_Pick_From_SplitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_pick_from_split = /** @type {((inputs: Ui_Studio_Pick_From_SplitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Pick_From_SplitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_pick_from_split(inputs)
	return de_ui_studio_pick_from_split(inputs)
});